<template>
  <div>
    <el-menu
      :background-color="background"
      active-text-color="red"
      :default-active="router"
      mode="horizontal"
      router
    >
      <el-menu-item v-if="user" index="/">
        <el-tooltip class="item" effect="dark" content="搜索" placement="top-start">
          <i class="el-icon-search"></i>
        </el-tooltip>

        <!-- <span slot="title">搜索</span> -->
      </el-menu-item>

      <el-menu-item index="/edit" v-if="publicedit || roles.includes('dbadmin')|| roles.includes('editadmin')">
        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
          <i class="el-icon-edit"></i>
        </el-tooltip>
        <!-- <span slot="title">编辑</span> -->
      </el-menu-item>

      <!-- 当prints数组长度大于0时显现 -->
      <el-menu-item index="/printaspdf" v-if="$store.state.prints.length>0">
        <i class="el-icon-printer"></i>
        <span class="tips">{{$store.state.prints.length}}</span>
      </el-menu-item>

      <!-- 当modifys数组长度大于0时显现 -->
      <el-menu-item index="/modifys" v-if="$store.state.modifys.length>0">
        <i class="el-icon-s-operation"></i>
        <span class="tips">{{$store.state.modifys.length}}</span>
      </el-menu-item>

      <!-- 当qtyreduce数组长度大于0时显现 -->
      <el-menu-item index="/qtyreduce" v-if="$store.state.qtyreduce.length>0">
        <i class="el-icon-remove"></i>
        <span class="tips">{{$store.state.qtyreduce.length}}</span>
      </el-menu-item>

      <!-- 当qtyincrease数组长度大于0时显现 -->
      <el-menu-item
        index="/qtyincrease"
        v-if="$store.state.qtyincrease.length>0"
      >
        <i class="el-icon-circle-plus"></i>
        <span class="tips">{{$store.state.qtyincrease.length}}</span>

        <!-- <span slot="title">{{$store.state.qtyincreasetitle[$store.state.clct]}}</span> -->
      </el-menu-item>

      <el-menu-item index="/aggregate" v-if="roles.includes('admin')">
        <el-tooltip class="item" effect="dark" content="综合" placement="top-start">
          <i class="el-icon-star-off"></i>
        </el-tooltip>
      </el-menu-item>

      <el-menu-item index="/received" v-if="roles.includes('admin')">
        <el-tooltip class="item" effect="dark" content="待处理数据" placement="top-start">
          <i class="el-icon-edit-outline"></i>
        </el-tooltip>
        <!-- <span slot="title">待处理数据</span> -->
      </el-menu-item>

      <div>
        <div style="margin-right:2rem;float:right">
          <!-- <el-switch></el-switch> -->
          <!-- <el-switch v-model="value1" active-text="chart"></el-switch> -->
          <el-tooltip effect="dark" content="图表开关" placement="top-start">
            <el-button
              type="text"
              style="margin-right:0.5rem"
              @click="$store.commit('setifchart')"
            >&#x1F4CA;</el-button>
          </el-tooltip>
          <el-button
            v-if="!user || user==='visitor'"
            style="font-weight:bold;font-size:1.2rem"
            @click="$router.push('/login')"
            type="text"
          >登录</el-button>

          <el-dropdown v-else @command="usercommand">
            <span style="color:blue;">
              {{user.slice(0,3)}}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="passchange">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown v-if="$store.state.roles.includes('superadmin')" @command="modelswitch">
            <span style="color:blue;">
              URL
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="theurl in urls" :key="theurl" :command="theurl">{{theurl}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
      </div>
    </el-menu>
  </div>
</template>

<style>
.el-menu {
  height: 35px;
}
.el-menu--horizontal > .el-menu-item {
  height: 30px;
  line-height: 30px;
}
.el-menu-item {
  padding: 0, 0.5rem;
}
</style>

<script>
import { itemscollection,activecollection } from "@/components/utility/indexdb";
export default {
  data() {
    return {
      router: this.$router.currentRoute.path,
      loading: false,
      urls:urls,
      currenturl:url
    };
  },
  computed: {
    background(){
      if(this.currenturl=="http://localhost/"){
        return '#b4b4cb'
      }
      else {
        return "#e6c3a5"
      }
    },
    publicedit() {
      if (this.$store.state.collection) {
        return this.$store.state.collection.publicedit;
      } else {
        return false;
      }
    },
    roles() {
      return this.$store.state.roles;
    },
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    $route(to, from) {
      this.router = to.path;
    },
    user() {
      //登录后store中roles改变，因而刷新navbar
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 10);
    }
  },

  methods: {
    modelswitch(command){
      urlswitch(command)
      this.currenturl=command
      this.$axios.appinitial()
    },
    usercommand(command) {
      if (command === "exit") {
        localStorage.clear();
        itemscollection.remove({});
        activecollection("headers").remove()
        this.$store.commit("reset");
        this.$store.commit("setUser", "");
        this.$router.push("/login");
      }
      if (command === "passchange") {
        this.$router.push("/passchange");
      }
    }
  }
};
</script>


<style scoped>
.tips {
  background: red;
  color: white;
  border-radius: 2rem;
  width: 1rem;
  height: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue